var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { "data-grm-comp": "RoomCBTLogUserInfo" } }, [
    _c("table", [
      _vm._m(0),
      _vm._m(1),
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.cbtLogUser.username))]),
          _c("td", [_vm._v(_vm._s(_vm.cbtLogUser.totalScore))]),
          _c("td", [_vm._v(_vm._s(_vm.duration(_vm.cbtLog.duration)))]),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm
                  .dayjs(_vm.cbtLogUser.beginDate)
                  .format("YYYY-MM-DD HH:mm:ss")
              ) +
                " ~ " +
                _vm._s(
                  _vm
                    .dayjs(_vm.cbtLogUser.endDate)
                    .format("YYYY-MM-DD HH:mm:ss")
                )
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "4" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("이름")]),
        _c("th", [_vm._v("점수")]),
        _c("th", [_vm._v("제한 시간")]),
        _c("th", [_vm._v("참여 시간")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }